import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from '@brunata-angular/util';
import {
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import {EventAlarmWithTranslations} from '../event-alarm.model';
import {EventAlarmPipe} from '@shared/pipes/event-alarm.pipe';

@Component({
    selector: 'app-event-alarms-card-view',
    standalone: true,
    imports: [
        CommonModule,
        TranslatePipe,
        NgbDropdown,
        NgbDropdownItem,
        NgbDropdownMenu,
        NgbDropdownToggle,
        EventAlarmPipe,
    ],
    templateUrl: './event-alarms-card-view.component.html',
    styleUrl: './event-alarms-card-view.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventAlarmsCardViewComponent {
    @Input() eventAlarms: EventAlarmWithTranslations[] = [];
    @Input() buildingNo: string | undefined;
    @Output() deleteEventAlarm: EventEmitter<EventAlarmWithTranslations> =
        new EventEmitter<EventAlarmWithTranslations>();
    @Output() editAlarm: EventEmitter<string> = new EventEmitter<string>();
    @Output() duplicateAlarm: EventEmitter<string> = new EventEmitter<string>();
}
